import { useTranslation } from 'react-i18next';
export function useCommonDataTableUiTranslation() {
    return useTranslation('common-data-table-ui');
}
